export default "__VITE_ASSET__LRjITpWh__"